import { all, call, put, takeLatest } from "redux-saga/effects";

import { getNewsDetailApi } from "core/http/service/news";

import { SCREEN } from "helper/roleChecker/Screens";
import {
  getNewsDetailFailed,
  getNewsDetailStart,
  getNewsDetailSuccess,
} from "../redux/getNewsDetail";

function* getNewsDetailWork(action) {
  const payload = action.payload;
  try {
    const res = yield call(getNewsDetailApi, {
      screenCode: SCREEN.IP_009,
      id: payload.id,
    });
    yield put({
      type: getNewsDetailSuccess.type,
      payload: res,
    });
  } catch (error: any) {
    yield put({
      type: getNewsDetailFailed.type,
    });
  }
}

function* watchGetNewsDetail() {
  yield takeLatest(getNewsDetailStart.type, getNewsDetailWork);
}

export default function* getNewsDetailSaga() {
  yield all([watchGetNewsDetail()]);
}
